// extracted by mini-css-extract-plugin
module.exports = {"item":"customItems_item__kBRMw","wrapper":"customItems_wrapper__3_zFD"};